<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['savings_report'] == 1 || userData.permissions['performance_reports'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <div class="mb-2 d-flex justify-content-md-start">
                <div class="form-group">
                <label>Date From</label>
                <input v-model="datefrom" type="date" class="form-control" />
                </div>
                <div class="form-group ms-2">
                <label>Date To</label>
                <input v-model="dateto" type="date" class="form-control" />
                </div>
                <span><br><b-button @click="FilterData" class="mt-2 mx-2" variant="primary"><i class="mdi mdi-filter"></i> Filter</b-button></span>
                <div><br><export-excel class="btn btn-info mt-2 mb-2" :data=reportwithdrawsperusers name="withdrawperusers.xls"> Export <i class="mdi mdi-download"></i></export-excel></div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(amounts)="data">
                {{ commas(data.item.amounts) }}
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <b>Total Withdraws : {{ commas(totalwithdraws) }}</b>
              </div>
              <div class="col">
                <b>Total Charges : {{ commas(totalcharges) }}</b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view {{ title }}</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { reportwithdrawsperuserMethods, reportwithdrawsperuserComputed } from "@/state/helpers";

export default {
  page: {
    title: "Withdraws Per User Report",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Withdraws Per User Report",
      items: [ {text: "Dashboard",to: "/",}, {text: "Withdraws Per User Report",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'userid', label: 'User ID', visible: true },
          { key: 'username', label: 'User Name', visible: true },
          { key: 'times', label: 'Times', visible: true },
          { key: 'amounts', label: 'Amount', visible: true },
          { key: 'charges', label: 'Charges', visible: true },
        ],
      datefrom: new Date().toLocaleDateString('fr-CA'),
      dateto: new Date().toLocaleDateString('fr-CA'),
    };
  },
  computed: {
    ...reportwithdrawsperuserComputed,
    List() { return this.reportwithdrawsperusers.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.reportwithdrawsperusers.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.reportwithdrawsperusers.length>0) { a=false;} else { a=true;} return a },
    totalwithdraws(){ var total = 0; this.reportwithdrawsperusers.forEach((item)=>{ var item_total = item.amounts; total = Number(total)+Number(item_total);}); return total },
    totalcharges(){ var total = 0; this.reportwithdrawsperusers.forEach((item)=>{ var item_total = item.charges; total = Number(total)+Number(item_total);}); return total },
  },
  mounted() {
    this.fetchReportWithdrawsPerUser();
    this.TotalRows = this.reportwithdrawsperusers.length;
    this.isBusy=false;
  },
  methods: {
    ...reportwithdrawsperuserMethods,
      Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    FilterData() {
      this.filterReportWithdrawsPerUser({datefrom:this.datefrom,dateto:this.dateto});
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  },
};
</script>